import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Icon } from "@chakra-ui/react";
import { FaHeadset } from "react-icons/fa";
import { openHelpDeskModal } from "../utils/helpDesk";

/**
 * Help Desk trigger button.
 *
 * Default behavior: opens the shared HelpDeskModal via openHelpDeskModal().
 * Pass `navigateToPage` to instead navigate to the standalone /help-desk page.
 */
const HelpDeskButton = ({ size = "md", buttonProps = {}, navigateToPage = false }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (navigateToPage) {
      navigate("/help-desk");
    } else {
      openHelpDeskModal();
    }
  };

  return (
    <Button
      size={size}
      colorScheme="red"
      leftIcon={<Icon as={FaHeadset} />}
      onClick={handleClick}
      {...buttonProps}
    >
      Help Desk
    </Button>
  );
};

export default HelpDeskButton;
